import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useInstructorAllReviews — GET /api/instructor/interview-sim/all?status=&page=
 * Returns paginated list of all sessions with optional status filter
 */
export function useInstructorAllReviews({ status = '', page = 1 } = {}) {
  const [reviews, setReviews] = useState([]);
  const [total, setTotal] = useState(0);
  const [thisWeekCompleted, setThisWeekCompleted] = useState(null);
  const [avgCcriTotal, setAvgCcriTotal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReviews = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const params = new URLSearchParams();
      if (status) params.set('status', status);
      params.set('page', String(page));

      const res = await axios.get(`${API}/instructor/interview-sim/all?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data;
      setReviews(Array.isArray(data) ? data : (data?.sessions || []));
      setTotal(data?.total || (Array.isArray(data) ? data.length : 0));
      // Backend f212bcb: this_week_completed = status=="scored" AND scoring.scored_at son 7 gün
      setThisWeekCompleted(
        typeof data?.this_week_completed === 'number' ? data.this_week_completed : null
      );
      // Backend 0e16799: avg_ccri_total = TÜM scored kayıtların ccri_total ortalaması (aggregate, sayfa-bağımsız)
      setAvgCcriTotal(
        typeof data?.avg_ccri_total === 'number' ? data.avg_ccri_total : null
      );
    } catch (err) {
      setError(err?.response?.data?.message_tr || err?.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, [status, page]);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  return { reviews, total, thisWeekCompleted, avgCcriTotal, loading, error, refetch: fetchReviews };
}
